export const getInTouchData = {
  buttons: [
    {
      label: 'Yes',
      id: 'Y',
    },
    {
      label: 'No',
      id: 'N',
    },
  ],
  title: 'Would you be happy for a member of the Which? team to get in touch?',
  standFirst:
    "Your experience could help inform our advice content, scams research or campaigning work. Selecting 'Yes' below will allow us to identify information provided via previous steps in the tool. Anything you tell us can be anonymised.",
  image: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/5e64c8f9579d-tooliconquestion.jpg',
  },
}
